const AirPreferencesMealTypeCodes = [
  // // this require input meal name
  // {
  //   label: 'All Other Special',
  //   value: 'SPML',
  // },
  {
    label: 'Bland',
    value: 'BLML',
  },
  {
    label: 'Child',
    value: 'CHML',
  },
  {
    label: 'Child Chicken',
    value: 'CHKN',
  },
  {
    label: 'Fruit Platter',
    value: 'FPML',
  },
  {
    label: 'Gluten Intolerant',
    value: 'GFML',
  },
  {
    label: 'Hamburger',
    value: 'GAHB',
  },
  {
    label: 'Heart Healthy',
    value: 'AHML',
  },
  {
    label: 'Hindu',
    value: 'HNML',
  },
  {
    label: 'Infant',
    value: 'BBML',
  },
  {
    label: 'Kosher',
    value: 'KSML',
  },
  {
    label: 'Low Calorie',
    value: 'LCML',
  },
  {
    label: 'Low Fat',
    value: 'LFML',
  },
  {
    label: 'Low Salt',
    value: 'LSML',
  },
  {
    label: 'Low carbohydrate',
    value: 'LCRB',
  },
  {
    label: 'Muslim',
    value: 'MOML',
  },
  {
    label: 'Non Lactose',
    value: 'NLML',
  },
  {
    label: 'Seafood',
    value: 'SFML',
  },
  {
    label: 'Vegetarian Hindu',
    value: 'AVML',
  },
  {
    label: 'Vegetarian Jain',
    value: 'VJML',
  },
  {
    label: 'Vegetarian Lacto-Ovo',
    value: 'VLML',
  },
  {
    label: 'Vegetarian Oriental',
    value: 'VOML',
  },
  {
    label: 'Vegetarian Raw',
    value: 'RVML',
  },
  {
    label: 'Vegetarian Vegan',
    value: 'VGML',
  },
];

export default AirPreferencesMealTypeCodes;
